import { alpha, RadioGroup, styled, Stack, Typography, Box, Button, Chip } from '@mui/material';
import { RadioBox, RadioBoxLabelComplex } from '@components';
import { useState } from 'react';

interface CloudProvider {
  type: string;
  name: string;
  description: string;
  icon: string;
  resourceType: string;
  disabled?: boolean;
}

interface CreateReportCloudProviderSelectorProps {
  providers: CloudProvider[];
  selectedProvider: string;
  onProviderSelect: (value: string) => void;
  onNotifyMe: (type: string) => void;
}

const SelectorWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: alpha(theme.palette.background.active, 0.48),
  borderRadius: theme.shape.borderRadius,
}));

const ComingSoonChip = styled(Chip)(({ theme }) => ({
  position: 'absolute',
  backgroundColor: theme.palette.background.default,
  top: theme.spacing(-1.5),
  right: theme.spacing(-1),
  color: theme.palette.text.muted,
}));

const ComingSoonContainer = styled(Box)({
  flex: 1,
  display: 'flex',
  justifyContent: 'flex-end',
  position: 'relative',
});

export default function CreateReportCloudProviderSelector({
  providers,
  selectedProvider,
  onProviderSelect,
  onNotifyMe,
}: CreateReportCloudProviderSelectorProps) {
  return (
    <SelectorWrapper>
      <Stack direction="column" spacing={2}>
        <Typography variant="subtitle2">Select Cloud Provider</Typography>
        <RadioGroup value={selectedProvider} onChange={(event) => onProviderSelect(event.target.value)}>
          <Stack direction="row" justifyContent="left" alignItems="stretch" spacing={2}>
            {providers.map((provider) => (
              <ComingSoonContainer key={provider.type}>
                {provider.disabled && <ComingSoonChip label="Coming Soon" size="small" variant="outlined" />}
                <RadioBox
                  key={provider.type}
                  value={provider.type}
                  label={
                    <Stack
                      direction="column"
                      spacing={0}
                      alignItems="center"
                      position="relative"
                      sx={{ width: '100%' }}
                    >
                      <RadioBoxLabelComplex
                        iconPath={provider.icon}
                        title={provider.name}
                        description={provider.description}
                      />
                      {provider.disabled && <NotifyMeButton onClick={() => onNotifyMe(provider.name)} />}
                    </Stack>
                  }
                  labelPlacement="top"
                  disabled={provider.disabled}
                  sx={{ flex: 1 }}
                />
              </ComingSoonContainer>
            ))}
          </Stack>
        </RadioGroup>
      </Stack>
    </SelectorWrapper>
  );
}

function NotifyMeButton({ onClick }: { onClick: () => void }) {
  const [clicked, setClicked] = useState(false);

  const handleClick = () => {
    setClicked(true);
    onClick();
  };

  return (
    <Box mb={2}>
      <Button variant="outlined" size="small" color="primary" onClick={handleClick} disabled={clicked}>
        Notify me
      </Button>
    </Box>
  );
}
